import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import config from "@/config";

Vue.use(Vuex);

const Project = {
  namespaced: true,
  state: {
    all_grants: [],
    my_projects: [],
    grant: {},
    uuid: localStorage.getItem('project_uuid'),
    title: localStorage.getItem('project_title'),
    grant_id: localStorage.getItem('grant_id'),
    project: {},
    reports: []
  },
  getters: {
    myProjects: state => state.my_projects || [],
    data: state => state.project || {},
    reports: state => state.reports || null,
    uuid: state => state.uuid || null,
    title: state => state.title || null,
    grant: state => state.grant_id || null,
  },
  mutations: {
    MY_PROJECTS(state, projects) {
      state.my_projects = projects
    },
    SET_UUID(state, uuid) {
      state.uuid = uuid;
      localStorage.setItem('project_uuid', uuid);
    },
    SET_PROJECT(state, project) {
      state.project = project;
      state.title = project.title;
      state.grant_id = project.grant_id;
      localStorage.setItem('project_title', project.title);
      localStorage.setItem('grant_id', project.grant_id);
    },
    SET_IMAGE(state,image){
      state.project.image = image
    }
  },
  actions: {
    myProjects({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(config.API_URL + '/projects')
          .then(response => {
            //console.log(response);
            commit("MY_PROJECTS", response.data);
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    get({ state, commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(config.API_URL + '/projects/' + state.uuid)
          .then(response => {
            //console.log(response);
            commit("SET_PROJECT", response.data.data);
            resolve();
          })
          .catch(error => {
            //console.log(error);
            reject(error);
          })
      })
    },
    update({ state, commit }) {
      return new Promise((resolve, reject) => {
        axios.put(config.API_URL + '/projects/' + state.uuid, { ...state.project })
          .then(response => {
            commit("SET_PROJECT", response.data.data);
            resolve(response.data);
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
};

export default Project;
